import {Sprite_MapInventoryStatText} from "./InventoryStatText.sprite";

export class Sprite_MapInvHelp extends KDCore.Sprite {
  constructor() {
    super();
    this._create();
  }

  setup(cell) {
    this.cell = cell;
    this._isStatsAllowed = false;
    this._statsIndex = 0;

    if (!this.cell) return;

    this.drawCost();
    this.drawName();
    this.drawType();
    this.drawDesc();
    this.showActionHelp();

    if (YsServices.equipmentService.get_AllowRareSystem()) {
      this.drawQLevel();
    }

    if (YsServices.equipmentService.get_AllowEquipStats()) {
      this.setupStats();
      this.showStatsHelp();
    }
  }

  // * Show (draw) help icon
  showStatsHelp() {
    if (!this._isStatsAllowed) return;

    const stats = this.basicSettings.EquipmentStats;

    const actionHelpSpr = KDCore.Sprite.FromTextSettings(stats.statsHelpText);
    actionHelpSpr.drawTextWithSettings(stats.helpIconText);
    this.content.addChild(actionHelpSpr);

    const helpIcon = YsServices.equipmentService.FromImgI("inventoryScrollHelp");
    helpIcon.move(KDCore.Utils.jsonPos(stats.helpIconPosition));
    this.content.addChild(helpIcon);
  };

  delay() {
    return this.settings.showDelay;
  }

  drawCost() {
    const text = this.cell.item.price;
    if(this._textCostSpr) {
      this._textCostSpr.drawTextWithSettings(text);
    }
  }

  drawName() {
    if (!this._textNameSpr) return;

    const text = this.cell.item.name;
    this._textNameSpr.drawTextWithSettings(text);

    if (!YsServices.equipmentService.isShowItemNameWithQualityColor()) return;

    this._drawNameWithQualityColor(text);
  }

  drawDesc() {
    this._description.contents.clear();
    const text = this.cell.item.description;

    // * why + 150 ???
    this._description.drawTextExWithWordWrap(text, 0, 0, this.settings.descriptionWindow.width + 150);
    this._description.contents.clear();

    this._description.drawTextExWithWordWrap(text, 0, 0, this.settings.descriptionWindow.width - 10);
  }

  drawType() {
    const type = this._getTypeText(this.cell.item);
    const text = type.text;

    this._textTypeSpr.bitmap.textColor = KDCore.Color.FromHex(type.color).CSS;

    if(this._textTypeSpr) {
      this._textTypeSpr.drawTextWithSettings(text)
    }
  }

  _create() {
    this._loadSettings();
    this._createBackground();
    this._createContent();
    this._createCorner();
  }

  _loadSettings() {
    this.basicSettings = this._settingsJSON();
    this.settings = this.basicSettings.helpWindow;
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createBackground() {
    this._background = KDCore.Sprite.FromBitmap(this.settings.width, this.settings.height);
    this._background.bitmap.fillAll(KDCore.Color.FromHex(this.settings.backgroundColor));
    this._background.opacity = this.settings.backgroundOpacity;
    this.add(this._background);
  }

  _createCorner() {
    this._corner = YsServices.equipmentService.FromImgI('inventoryHintCorner');
    this._background.add(this._corner);
  }

  _createContent() {
    this.content = new Sprite();
    this._createCost();
    this._createName();
    this._creatType();
    this._createDescription();
    this._createQLevel();
    this._createStats();
    this._background.add(this.content);
  }

  _createCost() {
    this._textCostSpr = KDCore.Sprite.FromTextSettings(this.settings.itemCostText);
    this.content.addChild(this._textCostSpr);

    this.goldIcon = YsServices.equipmentService.FromImgI(this.basicSettings.goldIcon);
    this.goldIcon.move(KDCore.Utils.jsonPos(this.settings.goldIconPosition));

    this.content.addChild(this.goldIcon);
  }

  _createName() {
    this._textNameSpr = KDCore.Sprite.FromTextSettings(this.settings.itemNameText);
    this.content.addChild(this._textNameSpr);
  }

  _creatType() {
    this._textTypeSpr = KDCore.Sprite.FromTextSettings(this.settings.itemTypeText);
    return this.content.addChild(this._textTypeSpr);
  }

  _createDescription() {
    const params = this.settings.descriptionWindow;
    this._description = new Window_Base(params.x, params.y, params.width, params.height);

    this._description.setBackgroundType(2);
    this.content.addChild(this._description);

    this._description.standardFontSize = function() {
      return params.fontSize;
    };

    this._description.lineHeight = function() {
      return 12;
    };

    this._description.standardPadding = function() {
      return 6;
    };

    if (params.fontFace) {
      return this._description.standardFontFace = function() {
        return params.fontFace;
      };
    }
  }

  _createQLevel() {
    if (!YsServices.equipmentService.get_AllowRareSystem()) {
      return;
    }

    this._textQLevelSpr = KDCore.Sprite.FromTextSettings(this.settings.itemQualityText);

    if (this.basicSettings.QualitySystem.qualityIcon) {
      const wIcon = YsServices.equipmentService.FromImgI(this.basicSettings.QualitySystem.qualityIcon);
      wIcon.move(KDCore.Utils.jsonPos(this.settings.qualityIconPosition));
      this.content.addChild(wIcon);
    }

    return this.content.addChild(this._textQLevelSpr);
  }

  _drawNameWithQualityColor(name) {
    const quality = DataManager.getItemQualityLevel(this.cell.item);

    if (quality < 0) {
      return;
    }

    this._textNameSpr.clear();
    this._textNameSpr.bitmap.textColor = YsServices.equipmentService.GetColorForQuealityLevel(quality);

    this._textNameSpr.drawTextFull(name, this.settings.itemNameText.position);
  }

  _getTypeText(item) {
    let specialColor, specialText;
    let color = null;
    let text = null;

    if (DataManager.isItem(item)) {
      if (item.itypeId === 1) { // * NORMAL
        if (item.consumable === true) {
          text = this.settings.consumableTypeText;
          color = this.settings.defaultTypeColors.consumableItem;
        } else {
          text = TextManager.item;
          color = this.settings.defaultTypeColors.normalItem; // * KEY
        }
      } else {
        text = TextManager.keyItem;
        color = this.settings.defaultTypeColors.keyItem;
      }
    } else {
      if (DataManager.isWeapon(item)) {
        text = $dataSystem.weaponTypes[item.wtypeId];
        color = this.settings.defaultTypeColors.weapon;
      } else if (DataManager.isArmor(item)) {
        text = $dataSystem.armorTypes[item.atypeId];
        color = this.settings.defaultTypeColors.armor;
      }
    }

    specialText = this._getItemSpecialTypeText(item);
    if (specialText) {
      text = specialText.trim();
    }

    specialColor = this._getItemSpecialTypeColor(item);
    if (specialColor) {
      color = specialColor.trim();
    }

    if (!text) text = "Unknown";
    if (!color) color = "#FFFFFF";

    return {text, color};
  }

  //@_description.drawTextEx text, 0, 0, @settings.descriptionWindow.width + 150
  showActionHelp() {
    if (!this.cell.isEnabled()) return;

    const item = this.cell.item;
    let text = "";

    if (DataManager.isItem(item)) {
      text = this.settings.helpUseItemText;
    } else {
      if (this.cell.isCanBeUnEquiped()) {
        text = this.settings.helpUnEquipItemText;
      } else {
        text = this.settings.helpEquipItemText;
      }
    }

    this._drawActionHelpText(text);
  }

  drawQLevel() {
    var color, qualityLevel, ref;
    qualityLevel = DataManager.getItemQualityLevel(this.cell.item);
    color = this._getColorForQualityLevel(qualityLevel);
    this._textQLevelSpr.b().textColor = color;
    return (ref = this._textQLevelSpr) != null ? ref.drawTextWithSettings(this._getTextForQualityLevel(qualityLevel)) : void 0;
  }

  // * When press button to show
  showItemStats(isUp) {
    if (!this._stats) return;
    if (!this._isStatsAllowed) return;

    for (let i = 0; i < this._statsAll.length; i++) {
      const stat = this._statsAll[i];
      stat.visible = false;
    }

    if (isUp) {
      this._statsIndex--;
    } else {
      this._statsIndex++;
    }

    if (this._statsIndex >= this._statsAll.length) {
      this._statsIndex = 0;
    } else {
      if (this._statsIndex < 0) {
        this._statsIndex = this._statsAll.length - 1;
      }
    }

    this._statsAll[this._statsIndex].visible = true;
  };

  // * When setup ITEM
  setupStats() {
    const item = this.cell.item;
    if (DataManager.isItem(item)) {
      return this._isStatsAllowed = false;
    } else {
      this._createAllStatesInfo();
      return this._isStatsAllowed = true;
    }
  };

  refreshPlacement() {
    if (YsServices.equipmentService.isStaticDescPosition() && YsServices.equipmentService.getStaticDescPosition()) {
      this._setStaticPosition();
    } else {
      const pos = this.getSourcePos();

      this.move(pos.x + this.settings.marginX, pos.y + this.settings.marginY);
      let dy;
      let dx = dy = 0;
      if (this._background.width + this.x + 5 > Graphics.boxWidth) {
        dx = 1;
        this.x -= this.settings.marginX;
      }

      if (this._background.height + this.y + 5 > Graphics.boxHeight) {
        dy = 1;
        this.y -= this.settings.marginY;
      }

      this._background.setStaticAnchor(dx, dy);
      this._refreshCornerPlacement(dx, dy);
    }
  }

  getSourcePos() {
    if (this.cell) {
      const x = KDCore.SDK.toGlobalCoord(this.cell, "x");
      const y = KDCore.SDK.toGlobalCoord(this.cell, "y");
      return new KDCore.Point(x, y);
    } else {
      return TouchInput;
    }
  }

  _getItemSpecialTypeText(item) {
    if (!item.meta) return null;

    let text = item.meta.aItemType;
    if (String.any(text)) {
      text = text.replaceAll("|", ", ");
    }

    return text;
  }

  _getItemSpecialTypeColor(item) {
    if (!item.meta) return null;
    return item.meta.aItemTypeColor;
  }

  _createStats() {
    this._statsAll = [];
    this._statsAll.push(this._description); // * always default

    if (!YsServices.equipmentService.get_AllowEquipStats()) return;

    this._statsBase = new Sprite(); // * container
    this._statsBase.move(this.basicSettings.EquipmentStats.position);

    this.content.addChild(this._statsBase);
  };

  // * Equip stats (basic)
  _createEqStatsA() {
    this._stats = YsServices.equipmentService.FromImgI(this.basicSettings.EquipmentStats.statsBackImage);
    this._stats.visible = false;
    this._statsBase.addChild(this._stats);
    this._statsAll.push(this._stats);
  };

  _drawActionHelpText(text) {
    if (text && text !== "") {
      const actionHelpSpr = KDCore.Sprite.FromTextSettings(this.settings.clickHelpText);
      actionHelpSpr.drawTextWithSettings(text);
      this.content.addChild(actionHelpSpr);

      const helpIcon = YsServices.equipmentService.FromImgI("inventoryClickHelp");
      helpIcon.move(KDCore.Utils.jsonPos(this.settings.helpIconPosition));
      return this.content.addChild(helpIcon);
    }
  }

  _getTextForQualityLevel(qualityLevel) {
    const levelData = this.basicSettings.QualitySystem.Levels[qualityLevel];
    if (!levelData) return "";

    return levelData[0];
  }

  _getColorForQualityLevel(qualityLevel) {
    return YsServices.equipmentService.GetColorForQuealityLevel(qualityLevel);
  }

  _setStaticPosition() {
    const position = YsServices.equipmentService.getStaticDescPosition();
    if (position) {
      this.move(position.x, position.y);
    }

    this._corner.visible = false;
  }

  _createAllStatesInfo() {
    this._createEqStatsA();
    this._createStatesParamsValues();
  };

  _createStatesParamsValues() {
    const stats = this.basicSettings.EquipmentStats.stats;
    let sprite;

    if (stats.atk.visible) {
      sprite = new Sprite_MapInventoryStatText("atk", this.cell);
      sprite.move(stats.atk.position);
      this._stats.addChild(sprite);
    }

    if (stats.def.visible) {
      sprite = new Sprite_MapInventoryStatText("def", this.cell);
      sprite.move(stats.def.position);
      this._stats.addChild(sprite);
    }

    if (stats.agi.visible) {
      sprite = new Sprite_MapInventoryStatText("agi", this.cell);
      sprite.move(stats.agi.position);
      this._stats.addChild(sprite);
    }

    if (stats.mat.visible === true) {
      sprite = new Sprite_MapInventoryStatText("mat", this.cell);
      sprite.move(stats.mat.position);
      this._stats.addChild(sprite);
    }

    if (stats.mdf.visible === true) {
      sprite = new Sprite_MapInventoryStatText("mdf", this.cell);
      sprite.move(stats.mdf.position);
      this._stats.addChild(sprite);
    }

    if (stats.luk.visible === true) {
      sprite = new Sprite_MapInventoryStatText("luk", this.cell);
      sprite.move(stats.luk.position);
      this._stats.addChild(sprite);
    }
  };

  _refreshCornerPlacement(dx, dy) {
    let pos;
    this._corner.scale.x = 1;
    this._corner.scale.y = 1;

    if (dx === 1 && dy === 0) {
      pos = this.settings.cornerPositions.topRight;
    }

    if (dx === 0 && dy === 0) {
      pos = this.settings.cornerPositions.topLeft;
      this._corner.scale.x = -1;
    }

    if (dx === 1 && dy === 1) {
      pos = this.settings.cornerPositions.downRight;
      this._corner.scale.y = -1;
    }

    if (dx === 0 && dy === 1) {
      pos = this.settings.cornerPositions.downLeft;
      this._corner.scale.x = -1;
      this._corner.scale.y = -1;
    }

    this._corner.move(KDCore.Utils.jsonPos(pos));
  }
}
